import { computed } from 'vue'
import type { Ref } from 'vue'

import { Temporal } from '@js-temporal/polyfill'

/**
 * Modeled after _interpret_start_and_end_times() in parkwhiz-rate-workers.
 */
export function useProductMaxDuration() {

  function getComputedsForStrings(
    firstStartTime: Ref<null | undefined | string>,
    lastStartTime: Ref<null | undefined | string>,
    endTime: Ref<null | undefined | string>,
  ) {

    const interpretedFirstStart = computed<null | Temporal.Duration>(() => {

      if (firstStartTime.value === null || firstStartTime.value === undefined || firstStartTime.value === '') {
        return null
      }

      const firstStart = Temporal.PlainTime.from(firstStartTime.value)
      return Temporal.Duration.from({hours: firstStart.hour, minutes: firstStart.minute})

    })

    const interpretedLastStart = computed<null | Temporal.Duration>(() => {

      if (lastStartTime.value === null || lastStartTime.value === undefined || lastStartTime.value === '') {
        return null
      }

      const lastStart = Temporal.PlainTime.from(lastStartTime.value)
      let lastStartAsDuration = Temporal.Duration.from({hours: lastStart.hour, minutes: lastStart.minute})

      if (interpretedFirstStart.value && Temporal.Duration.compare(lastStartAsDuration, interpretedFirstStart.value) === -1) {
        lastStartAsDuration = lastStartAsDuration.add({days: 1})
      }

      return lastStartAsDuration

    })

    const interpretedEnd = computed<null | Temporal.Duration>(() => {

      if (endTime.value === null || endTime.value === undefined || endTime.value === '') {
        return null
      }

      const end = Temporal.PlainTime.from(endTime.value)
      let endAsDuration = Temporal.Duration.from({hours: end.hour, minutes: end.minute})

      if (!interpretedFirstStart.value || (interpretedFirstStart.value && Temporal.Duration.compare(endAsDuration, interpretedFirstStart.value) !== 1)) {
        endAsDuration = endAsDuration.add({days: 1})
      }

      if (interpretedLastStart.value && Temporal.Duration.compare(endAsDuration, interpretedLastStart.value) !== 1) {
        endAsDuration = endAsDuration.add({days: 1})
      }

      return endAsDuration

    })

    const maxTierDurationInHours = computed<null | number>(() => {

      if (!interpretedFirstStart.value || !interpretedEnd.value) {
        return null
      }

      const maxTierDuration = interpretedEnd.value.subtract(interpretedFirstStart.value)
      return maxTierDuration.hours

    })

    return {
      interpretedFirstStart,
      interpretedLastStart,
      interpretedEnd,
      maxTierDurationInHours,
    }

  }

  return {
    getComputedsForStrings,
  }

}

